import React from 'react';

import { MagnifyingGlassIcon } from '@adsk/alloy-react-icon';
import TextInput from '@adsk/alloy-react-text-input';
import theme from '@adsk/alloy-react-theme';

import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { useTranslation } from '../i18n';
import { SubmittalsItem } from '../types';

const SearchBox: ReferencePickerPlugin<SubmittalsItem>['CustomPickerSearchBox'] =
  ({ searchExpression, onSearchChange, disabled }) => {
    const { t } = useTranslation();

    return (
      <TextInput
        style={{
          width: 300,
          'input:disabled': {
            background: theme.colors.white,
          },
        }}
        renderRightElement={MagnifyingGlassIcon.renderIcon}
        placeholder={t('SEARCH_BOX_PLACEHOLDER_WITH_CUSTOM_NUMBER')}
        value={searchExpression || ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onSearchChange(e.target.value)
        }
        disabled={disabled}
      />
    );
  };

SearchBox.displayName = 'SubmittalsSearchBox';

export default SearchBox;
